export default {
    error: 'Error',
    wrongPassword: 'Wrong password',
}